"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVector2d = void 0;
var immutable_1 = require("../../immutable");
exports.IVector2d = (0, immutable_1.IRecord)({ x: 0, y: 0 });
